import React, { Component, useState, Fragment, useEffect, useMemo, useRef } from 'react';
import { withStyles } from "@material-ui/core/styles";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeIcon from '@mui/icons-material/Home';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import GrainIcon from '@mui/icons-material/Grain';
import LightModeIcon from '@mui/icons-material/LightMode';
import Checkbox from '@mui/material/Checkbox';
import ClearIcon from '@material-ui/icons/Clear';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { AppBar, Toolbar, Typography, Button, IconButton, Modal, Grid, Box, TextField, FormControl, InputLabel, Drawer, Menu, Paper } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import Card from '@material-ui/core/Card';
import SearchIcon from '@material-ui/icons/Search';
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import EditIcon from '@mui/icons-material/Edit';
import { PostAddOutlined } from '@mui/icons-material';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { customTheme, getColorfont, getColor } from '../../../StyleComponents/Styledatatable';
import classNames from 'classnames';
import ApprovalIcon from '@mui/icons-material/Approval';
import FilterListIcon from '@mui/icons-material/FilterAlt';
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import AccordionSummary from '@mui/material/AccordionSummary';
import SettingsIcon from '@mui/icons-material/Settings';
import useStyles from '../../../StyleComponents/StyleFunctionComponent';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Popover from '@mui/material/Popover';
import Skeleton from '@material-ui/lab/Skeleton';
import LinearProgress from '@mui/material/LinearProgress';
import { API_BASE_URL, token, userLevel, adminId } from '../../../../constants';

const SocialCampaigns = () => {
    const history = useHistory();
    const [openSidebar, setOpenSidebar] = useState(false);
    const [filterText, setFilterText] = useState("");
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [perPage, setPerPage] = useState(50);
    const [page, setPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const currentDate = new Date();
    const sevenDaysAgo = new Date(currentDate);
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 5);

    const [fromDate, setFromDate] = useState(sevenDaysAgo.toISOString().split('T')[0]);
    const [toDate, setToDate] = useState(currentDate.toISOString().split('T')[0]);



    const [selectedState, setSelectedState] = useState();
    const [stateOptions, setStateOptions] = useState([]);


    const [selectedBrand, setSelectedBrand] = useState();
    const [brandOptions, setBrandOptions] = useState([]);

    const [selectedRows, setSelectedRows] = useState([]);

    const [updatedData, setUpdatedData] = useState({
        status: '',
        // email: '',
        // Add other fields you want to update
    });

    // @@@@@@@@@@@@@@@@@@@@@@@ start 
    const [doubleClickedRow, setDoubleClickedRow] = useState(null);
    const [message, setMessage] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');

    const [campaignOptions, setCampaignOptions] = useState([]);
    const [selectedCampaign, setSelectedCampaign] = useState("");
    const [moveType, setMoveType] = useState("");
    const [isVerified, setIsVerified] = useState("");

    useEffect(() => {
        const fetchCampaignList = async () => {
            try {
                const config = {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": `${token}`,
                    }
                };

                const response = await axios.post(
                    `${API_BASE_URL}/api/admin/v2/campaign-list`,
                    {},
                    config
                );

                const campaigns =
                    response?.data?.data?.assigned_list?.map((item, index) => ({
                        id: item.id,
                        title: item.campaign_id
                    })) || [];

                setCampaignOptions(campaigns);

            } catch (error) {
                console.log(error);
            }
        };

        fetchCampaignList();
    }, []);


    useEffect(() => {
        const fetchDatabrand = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };

                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/brand-list`, config);

                const statelist = response.data.data.map(item => ({
                    id: item.brand_id,
                    title: item.brand_name,
                }));

                setBrandOptions(statelist);

            } catch (error) {
                console.error('Error fetching state:', error);
            }
        };

        fetchDatabrand();
    }, []);

    useEffect(() => {
        const fetchDatastate = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };

                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/state-list`, config);
                const statelist = response.data.data.map(item => ({
                    id: item.state_id,
                    title: item.state_name,
                }));

                setStateOptions(statelist);

            } catch (error) {
                console.error('Error fetching state:', error);
            }
        };

        fetchDatastate();
    }, []);

    const handleStateChange = (event, newValue) => {
        setSelectedState(newValue);
    };

    const handleBrandChange = (event, newValue) => {
        setSelectedBrand(newValue);
    };

    const fetchData = async () => {
        setIsLoading(true);

        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": token,
                    "adminId": adminId,
                    "userLevel": userLevel
                }
            };

            const payload = {
                campaign_id: selectedCampaign ? Number(selectedCampaign) : null,
                state_id: selectedState?.id || null,
                from_date: fromDate,
                to_date: toDate,
                is_verified: isVerified || null,
                pagination: perPage,
                page: page + 1
            };

            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/socialcampaign-enquiry-list`,
                payload,
                config
            );

            const rows =
                response?.data?.data?.social_campaigns?.map((item, index) => ({
                    id: item.id,
                    serial: page * perPage + index + 1,
                    full_name: `${item.first_name} ${item.last_name}`,
                    mobile: item.mobile,
                    campaign_id: item.campaign_id,
                    state: item.state,
                    city: item.city,
                    created_at: new Date(item.created_at).toLocaleString("en-IN")
                })) || [];

            setData(rows);
            setTotalCount(response.data.data.total);

        } catch (error) {
            console.log(error);
            setSnackbarMessage("Failed to fetch data");
            setSnackbarOpen(true);
        } finally {
            setIsLoading(false);
        }
    };

    const source = axios.CancelToken.source();


    const sourceRef = useRef(null);

    useEffect(() => {
        fetchData();
    }, [page, perPage, selectedCampaign, selectedState, fromDate, toDate, isVerified]);



    const handleDateChange = (e) => {
        const { name, value } = e.target;
        if (name === 'fromDate') {
            setFromDate(value);
        } else if (name === 'toDate') {
            setToDate(value);
        }
    };




    const handleSubmit = (e) => {
        e.preventDefault();
        setPage(0);
        fetchData();
        setOpenSidebar(false);
    };
    const clearForm = () => {
        setSelectedCampaign("");
        setSelectedState(null);
        setFromDate(sevenDaysAgo.toISOString().split("T")[0]);
        setToDate(currentDate.toISOString().split("T")[0]);
        setIsVerified("");
        setPage(0);
        fetchData();
        setOpenSidebar(false);
    };


    const handleSelectAllCheck = () => {
        if (selectedRows.length === data.length) {
            setSelectedRows([]);
        } else {
            setSelectedRows(Array.from({ length: data.length }, (_, i) => i));
        }
    };

    const handleRowSelect = (rowIndex) => {
        if (selectedRows.includes(rowIndex)) {
            setSelectedRows(selectedRows.filter((row) => row !== rowIndex));
        } else {
            setSelectedRows([...selectedRows, rowIndex]);
        }
    };

    const handleRowsSelect = (currentRowsSelected, allRowsSelected) => {
        setSelectedRows(allRowsSelected.map((row) => row.index));
    };

    const handleRowsDelete = (rowsDeleted) => {
        console.log('Rows to be deleted:', rowsDeleted);
    };

    const handleSubmits = async () => {

        if (!moveType) {
            setSnackbarMessage("Select move type");
            setSnackbarOpen(true);
            return;
        }

        if (!selectedCampaign) {
            setSnackbarMessage("Select campaign");
            setSnackbarOpen(true);
            return;
        }

        try {
            setIsLoading(true);

            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`
                }
            };

            const payload = {
                move_type: Number(moveType),
                campaign_id: Number(selectedCampaign),
                state_id: selectedState?.id || null,
                from_date: fromDate,
                to_date: toDate,
                id_selected: selectedRows.map(i => data[i].id)

            };

            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/move-to-campaign-enquiry`,
                payload,
                config
            );

            setSnackbarMessage(response.data.message);
            setSnackbarOpen(true);
            setSelectedRows([]);
            fetchData();

        } catch (error) {
            setSnackbarMessage(
                error?.response?.data?.message || "Something went wrong"
            );
            setSnackbarOpen(true);
        } finally {
            setIsLoading(false);
        }
    };

    const columns = [
        {
            name: 'id',
            label: (
                <input
                    type="checkbox"
                    checked={selectedRows.length === data.length && data.length !== 0}
                    onChange={handleSelectAllCheck}
                />
            ),
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta) => (
                    <input
                        type="checkbox"
                        checked={selectedRows.includes(tableMeta.rowIndex)}
                        onChange={() => handleRowSelect(tableMeta.rowIndex)}
                    />
                ),
            },
        },
        {
            name: 'id', options: {
                filter: true,
                setCellProps: () => ({
                    align: "left",
                })
            },
            label: "S/N",
        },
        {
            name: 'full_name', options: {
                filter: true,
                setCellProps: () => ({
                    align: "left",
                })
            },
            label: "Full Name",
        },

        {
            name: "mobile",
            label: "Mobile",
            options: {
                filter: true,
                setCellProps: () => ({
                    align: "left",
                })
            },
        },
        {
            name: "Email",
            label: "Email ID",
        },
        {
            name: "campaign_id",
            label: "Campaign ID",
        },
        {
            name: "state",
            label: "State",
            options: {
                filter: true,
                setCellProps: () => ({
                    align: "left",
                })
            },
        },
        {
            name: "city",
            label: "City ",
        },
        {
            name: "Taluka",
            label: "Taluka ",
        },

        {
            name: "pincode",
            label: "Pincode",
        },
        {
            name: "created_at",
            label: "Date",
        },
    ]
    const CustomToolbarAction = ({ toggleFilter }) => (
        <IconButton aria-label="Filter list" onClick={toggleFilter}>
            <FilterListIcon onClick={toggleSidebar} />
        </IconButton>
    );
    const toggleSidebar = () => {
        setOpenSidebar(!openSidebar);
    };

    const handleRowClick = (rowIndex) => {
        const isSelected = selectedRows.includes(rowIndex);
        if (isSelected) {
            setSelectedRows(selectedRows.filter((row) => row !== rowIndex));
        } else {
            setSelectedRows([...selectedRows, rowIndex]);
        }
    };

    const options = {
        onRowClick: (rowData, rowMeta) => handleRowClick(rowMeta.dataIndex),
        selectableRows: 'multiple',
        onRowsSelect: handleRowsSelect,
        onRowsDelete: handleRowsDelete,
        rowsPerPage: perPage,
        selectableRows: 'none',
        page: page,
        serverSide: true,
        count: totalCount,
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setPage(tableState.page);
                    break;
                case 'changeRowsPerPage':
                    setPerPage(tableState.rowsPerPage);
                    setPage(0);
                    break;
                default:
                    break;
            }
        },

        customToolbar: () => <CustomToolbarAction />,
        filter: false,
        filterType: "dropdown",
        responsive: "standard",
        fixedHeader: true,
        fixedSelectColumn: true,
        overflowy: "auto",
        overflowx: "auto",
        rowsPerPageOptions: [10, 50, 100, 500, 1000, 10000, { value: totalCount, label: 'All' }],
        customFilterDialogFooter: (currentFilter, applyNewFilter) => (
            <div>
                <TextField
                    label="Filter Data"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                    fullWidth
                />
                <Button onClick={applyNewFilter} variant="contained" color="primary">
                    Apply Filter
                </Button>
                <Button onClick={() => setOpenSidebar(false)} variant="contained" color="secondary">
                    Cancel
                </Button>
            </div>
        ),
        setRowProps: (row, dataIndex, rowIndex) => ({
            style: {
                backgroundColor: doubleClickedRow === rowIndex ? '#D2DE32' : selectedRows.includes(dataIndex) ? '#D2DE32' : 'inherit',
            },
            onDoubleClick: () => handleRowDoubleClick(row, rowIndex),
        }),

    };
    const currentTheme = customTheme(true);
    const classes = useStyles();
    const memoizedData = useMemo(() => data, [data]);

    const handleRowDoubleClick = (row, rowIndex) => {
        console.log("Row double-clicked:", row);
        console.log("Row index:", rowIndex);
        const updatedSelectedRows = [...selectedRows];
        const rowIndexInSelectedRows = updatedSelectedRows.indexOf(rowIndex);
        if (rowIndexInSelectedRows === -1) {
            updatedSelectedRows.push(rowIndex);
        } else {
            updatedSelectedRows.splice(rowIndexInSelectedRows, 1);
        }
        setSelectedRows(updatedSelectedRows);
    };

    const handleSelectedRowsCount = () => {
        return selectedRows.length;
    };
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };
    return (
        <>
            {message && <p
                className={classes.message}
            >{message}</p>}
            <div>
                <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                    <MuiAlert onClose={handleCloseSnackbar} severity="info" sx={{ width: '100%' }}>
                        {snackbarMessage}
                    </MuiAlert>
                </Snackbar>
            </div>

            <Box sx={{ width: '100%' }}>
                <Grid container>
                    <Grid item xs={6} style={{ marginTop: "8px" }}>
                        <Typography className={classNames(classes.pagetittle, classes.pagetittlestyle)}>
                            Social Campaigns Report
                        </Typography>
                    </Grid>
                </Grid>
                <hr className={classes.horizontalline} />

            </Box>
            <div className={classes.root}>
                <div className={classes.root}  >
                    <Grid container spacing={1}>
                        <Grid item xs={4} sm={2} lg={3} >
                            <input
                                type="date"
                                name="fromDate"
                                value={fromDate}
                                onChange={handleDateChange}

                                className={classes.inputform}

                            />
                        </Grid>

                        <Grid item xs={4} sm={2} lg={3}>
                            <input
                                className={classes.inputform}
                                type="date"
                                name="toDate"
                                value={toDate}
                                onChange={handleDateChange}

                            />
                        </Grid>
                        <Grid item xs={4} sm={2} lg={3}>
                            <select
                                className={classes.selectform}
                                value={selectedCampaign}
                                onChange={(e) => setSelectedCampaign(e.target.value)}
                            >
                                <option value="">Campaign ID</option>

                                {campaignOptions.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.title}
                                    </option>
                                ))}
                            </select>
                        </Grid>
                        <Grid item xs={4} sm={2} lg={3} >
                            <Autocomplete
                                classes={{
                                    option: classes.autocompleteoption,
                                }}
                                // multiple 
                                options={brandOptions}
                                getOptionLabel={(option) => option.title}
                                renderInput={(params) => (
                                    <TextField {...params} placeholder='Select brand' variant="outlined" />
                                )}
                                value={selectedBrand}
                                onChange={handleBrandChange}
                                disableCloseOnSelect
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                getOptionSelected={(option, value) => option.id === value.id}
                                renderOption={(props, option, { selected }) => (
                                    <li {...props}>
                                        {option.title}
                                    </li>
                                )}
                            />
                        </Grid>
                        <Grid item xs={4} sm={2} lg={3} >
                            <Autocomplete
                                // multiple  
                                classes={{
                                    option: classes.autocompleteoption,
                                }}
                                options={stateOptions}
                                getOptionLabel={(option) => option.title}
                                renderInput={(params) => (
                                    <TextField {...params} placeholder='Select State' variant="outlined" />
                                )}
                                value={selectedState}
                                onChange={handleStateChange}
                                disableCloseOnSelect  // Keep the dropdown open after selecting an option
                                isOptionEqualToValue={(option, value) => option.id === value.id} // Customize option equality check
                                getOptionSelected={(option, value) => option.id === value.id} // Customize how options are considered selected
                                renderOption={(props, option, { selected }) => (
                                    <li {...props}>
                                        {option.title}
                                    </li>
                                )}
                            />
                        </Grid>
                        <Grid item xs={4} sm={2} lg={3}>
                            <select
                                className={classes.selectform}
                                value={moveType}
                                onChange={(e) => setMoveType(e.target.value)}
                            >
                                <option value="">Select Option</option>
                                <option value="1">Move To Bulk</option>
                                <option value="2">Download and Supplier</option>
                                <option value="3">Move To Escort Brand</option>
                                <option value="4">Trash</option>
                            </select>
                        </Grid>

                        <Grid item xs={4} sm={2} lg={3} >
                            <Button
                                onClick={handleSubmits}
                                style={{ backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                                className={classes.buttonform}
                                variant="outlined"
                                startIcon={<AssignmentIndIcon />}
                            > <span
                            > {handleSelectedRowsCount()}</span>-Move Enquiry
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </div>
            <br />
            <MuiThemeProvider theme={customTheme()}>
                {
                    isLoading ? (
                        <LinearProgress />

                    ) : (
                        ""
                    )
                }
                <MUIDataTable
                    title={
                        isLoading ? (
                            <Skeleton animation="wave" />

                        ) : (
                            <Typography className={classes.tabletittle} >
                                Social Campaigns Report
                            </Typography>
                        )
                    } data={memoizedData}
                    columns={columns}
                    options={options}
                />

            </MuiThemeProvider>

            <Drawer anchor="right" open={openSidebar}
                PaperProps={{
                    style: {
                        width: "100%",
                        maxWidth: 300,
                        padding: "10px"
                    }
                }}
                onClose={() => setOpenSidebar(false)}
            >
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={1}>
                        <Grid item xs={4} sm={2} lg={12} style={{ textAlign: "right", cursor: "pointer", }}>

                            <ClearIcon style={{ color: '#c0392b' }} onClick={() => setOpenSidebar(false)} />
                        </Grid>
                        <Grid item xs={4} sm={2} lg={12} >
                            <br />
                            <Typography className={classes.tabletittle} >
                                Filter
                            </Typography>
                        </Grid>
                    </Grid>
                    <div className={classes.root} style={{ paddingRight: "22px", paddingLeft: "22px" }}>
                        <div className={classes.root}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} lg={12} >
                                    <select
                                        className={classes.inputform}
                                        value={selectedCampaign}
                                        onChange={(e) => setSelectedCampaign(e.target.value)}
                                    >
                                        <option value="">Select Campaign</option>
                                        {campaignOptions.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.title}
                                            </option>
                                        ))}
                                    </select>

                                </Grid>
                                <Grid item xs={12} sm={12} lg={12} >
                                    <Autocomplete
                                        // multiple  
                                        classes={{
                                            option: classes.autocompleteoption,
                                        }}
                                        options={stateOptions}
                                        getOptionLabel={(option) => option.title}
                                        renderInput={(params) => (
                                            <TextField {...params} placeholder='Select State' variant="outlined" />
                                        )}
                                        value={selectedState}
                                        onChange={handleStateChange}
                                        disableCloseOnSelect
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        getOptionSelected={(option, value) => option.id === value.id}
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                {option.title}
                                            </li>
                                        )}
                                    />



                                </Grid>
                                <Grid item xs={12}>
                                    <input
                                        className={classes.inputform}
                                        type="date"
                                        name="fromDate"
                                        value={fromDate}
                                        onChange={handleDateChange}
                                    />
                                </Grid>

                                {/* To Date */}
                                <Grid item xs={12}>
                                    <input
                                        className={classes.inputform}
                                        type="date"
                                        name="toDate"
                                        value={toDate}
                                        onChange={handleDateChange}
                                    />
                                </Grid>
                                {/* Verification */}
                                <Grid item xs={12}>
                                    <select
                                        className={classes.inputform}
                                        value={isVerified}
                                        onChange={(e) => setIsVerified(e.target.value)}
                                    >
                                        <option value="">Verification</option>
                                        <option value="verified">Verified</option>
                                        <option value="unverified">Unverified</option>
                                    </select>
                                </Grid>


                            </Grid>
                        </div>
                    </div>
                    <br />
                    <Grid >
                        <Grid item xs={4} sm={2} lg={12} style={{ margin: "auto", padding: "auto", textAlign: "center" }}>
                            <Button
                                type='submit'
                                style={{ marginRight: "10px" }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ApprovalIcon />}>
                                Apply
                            </Button>
                            <Button
                                type="button" onClick={clearForm}
                                style={{ backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ClearIcon />}>
                                Clear
                            </Button>

                        </Grid>
                    </Grid>
                    <br />
                </form>
            </Drawer >
        </>
    );
};

export default SocialCampaigns;


